module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"passReset":"Восстановление пароля","newPass":"Новый пароль","confirmPass":"Еще раз","reset":"Восстановить","registration":"Регистрация","login":"Вход"}}')
  delete Component.options._Ctor
}
